export default "__VITE_ASSET__8850b7cb__"